import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import SafeImage from "./SafeImage";

export default function ArticleCard({ article, featured = false, testid }) {
  const { tr, lang } = useI18n();
  const categoryLabels = {
    fr: { finance: "Finance", politique: "Politique", "socio-culturel": "Socio-culturel", interview: "Interview", top: "Classement", sport: "Sport" },
    en: { finance: "Finance", politique: "Politics", "socio-culturel": "Socio-cultural", interview: "Interview", top: "Ranking", sport: "Sport" },
  };
  const catLabel = categoryLabels[lang]?.[article.category] || article.category;
  // Articles may optionally override their destination (e.g. special-edition landing pages)
  const target = article.external_url || `/articles/${article.slug}`;

  return (
    <Link
      to={target}
      className={`group block gai-card gai-sharp overflow-hidden flex flex-col ${featured ? "md:col-span-2 md:row-span-2" : ""}`}
      data-testid={testid || `article-card-${article.id}`}
    >
      <div
        className="relative w-full overflow-hidden"
        style={{ paddingTop: featured ? "60%" : "64%", backgroundColor: "var(--gai-grey-100)" }}
      >
        <SafeImage
          src={article.cover_url}
          alt={tr(article.title)}
          fallbackLabel={catLabel}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
        />
        <div className="absolute top-0 left-0 flex items-center gap-0">
          <span
            className="px-3 py-1.5 font-bold text-[0.6rem] tracking-[0.22em] uppercase"
            style={{ background: "var(--gai-red)", color: "var(--gai-white)" }}
          >
            {catLabel}
          </span>
          {article.is_premium && (
            <span
              className="px-2.5 py-1.5 font-bold text-[0.6rem] tracking-[0.18em] uppercase"
              style={{ background: "var(--gai-black)", color: "var(--gai-white)" }}
              data-testid="article-premium-badge"
            >
              {new Intl.NumberFormat("fr-FR", { style: "currency", currency: article.currency || "EUR", maximumFractionDigits: 0 }).format(article.price || 4)}
            </span>
          )}
        </div>
      </div>
      <div className="p-6 flex-1 flex flex-col">
        <h3
          className={`serif ${featured ? "text-2xl md:text-3xl" : "text-lg md:text-xl"} leading-[1.15] transition-colors`}
          style={{
            color: "var(--gai-black)",
            fontFamily: "'Playfair Display', serif",
            fontWeight: 600,
          }}
        >
          {tr(article.title)}
        </h3>
        <p
          className="mt-3 text-sm line-clamp-3 leading-relaxed flex-1"
          style={{ color: "var(--gai-grey-600)" }}
        >
          {tr(article.excerpt)}
        </p>
        <div
          className="mt-5 pt-4 flex items-center justify-between text-[0.65rem] tracking-[0.2em] uppercase font-semibold"
          style={{ borderTop: "1px solid var(--gai-grey-200)", color: "var(--gai-grey-500)" }}
        >
          <span>{article.author || "GAI"}</span>
          <span style={{ color: "var(--gai-red)" }} className="transition-transform group-hover:translate-x-1">→</span>
        </div>
      </div>
    </Link>
  );
}
